<template>
<div>
  <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
  <b-card-text v-if="students.length > 0 && loading === false">
     <div v-for="(student, index) in students" class="tasklists-row">
     <div class="row tasklist-item" style="margin: 0px;">
       <div class="col-xl-5 col-5">
       <router-link :to="{ path: '/students-task/' + student.id }">
       {{student.first_name}} {{student.last_name}}
       </router-link>
       </div>
       <div class="col-xl-5  col-5 override-padding">{{student.email}}</div>

      <div class="col-xl-2 col-2 override-padding">
          <div v-bind:id="'dropdown-container'+ index" class="dropdown" @click="toggleDropdown('actionDropdown'+index+'')">
          <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index">
            <li></li>
            <li></li>
            <li></li>
          </ul>
          <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
            <div class="action-dd-menu"  @click="goToEdit(student.id)"><i class="cursor-pointer fa fa-edit spacer-icon"></i>Edit</div>
            <div class="action-dd-menu"  @click="assignTasklist(student.id)"><i class="cursor-pointer fa fa-upload spacer-icon"></i>Assign Tasklist</div>
          </div>
          </div>
      </div>

      </div>
      <div><hr></div>
    </div>
    <div v-if="rows > perPage" class="overflow-auto float-right pagination-wrapper">
       <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        first-text="First"
        prev-text="Prev"
        next-text="Next"
        last-text="Last"
        @input="goToPagination()"
        hide-goto-end-buttons=0
        ></b-pagination>
    </div>
    </b-card-text>
    <div v-if="students.length == 0 && loading === false" class="noitems-custom-msg">No students assigned for this group</div>
   </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import router from '../../router/index.js';

export default {
      props: ['groupId'],
      data() {
       return {
         loading: false,
         students: [],
         rows: 0,
         perPage: 25,
         currentPage: 1,
       }
      },
      methods: {
      fetchStudentList() {
        this.loading = true;
        const params = { _page: this.currentPage }
        axios.get('/students/'+this.groupId, {
           params: params
        })
        .then((resp) => {
            this.loading = false;
            this.students = resp.data.data;
            this.currentPage = resp.data.page;
            this.rows = resp.data.total_rows;
        })
        .catch(error => {

        });
      },
      goToPagination() {
         this.fetchStudentList();
      },
      toggleDropdown (id) {
          document.getElementById(id).classList.toggle("show");
      },
      goToEdit(id) {
         router.push("/profile/" + id);
      },
      assignTasklist(id) {
         router.push("/edit/student-tasklist-assignment/" + id + "/" + this.groupId);
      },
      hideActionMenu(e) {
           var matches = document.getElementsByClassName('dropdown-content');
           for (var i=0; i<matches.length; i++) {
             var container = document.getElementById('dropdown-container'+ i);

             if (!container.contains(e.target)) {
                  if (document.getElementById('actionDropdown' + i).classList.contains("show")) {
                     document.getElementById('actionDropdown' + i).classList.remove('show');
                  }
             }
           }
     },
    },
    mounted() {
         document.addEventListener('click', this.hideActionMenu);
    },
    beforeDestroy() {
         document.removeEventListener('click', this.hideActionMenu);
    },
    created() {
      this.fetchStudentList();
    }
  }
</script>

<style>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 0.4em;
}
.tasklist-item {
    padding: 12px 0px 12px 0px;
}
hr {
    border-top: 2px solid #8b8b8b;
    margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/primaryadmin/studentlists.vue